module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M2-06a9d09f82a6be685c367e8029a1b843.webp";